<template>
    <p>{{body}}</p>
</template>

<script lang="ts">
import Vue from 'vue'
export default Vue.extend({
    name: 'TextCard',
    props: {
        body: String,
    }
})
</script>